import { EPlatform } from '../utils/enums/platform-enum';

type SnowplowGzipEnvValue = 'true' | 'false' | undefined;
type SnowplowAppEnvValue = 'local' | 'dev' | 'test' | 'uat' | 'prod';

const SNOWPLOW_APP_ID_SUFFIX_PATTERN = /_(?:pc|m)_(?:local|dev|test|uat|prod)$/;

export function resolveSnowplowGzipEnabled(value: SnowplowGzipEnvValue): boolean {
  return value !== 'false';
}

export function resolveSnowplowAppId(
  appIdBase: string | undefined,
  deviceType: EPlatform,
  envName: SnowplowAppEnvValue,
): string {
  const normalizedAppIdBase = (appIdBase?.trim() || 'z_us').replace(
    SNOWPLOW_APP_ID_SUFFIX_PATTERN,
    '',
  );
  const deviceSegment = deviceType === EPlatform.WEB ? 'pc' : 'm';

  return `${normalizedAppIdBase}_${deviceSegment}_${envName}`;
}
